import { TimeKeepingRecords } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitTimeKeeping/types';

export const computeRecordsDuration = (records: TimeKeepingRecords[]): number =>
  records.reduce((acc, record) => {
    if (record.datetimeEnd === '0') return acc;
    const diff = new Date(record.datetimeEnd).getTime() - new Date(record.datetimeStart).getTime();
    return acc + (diff > 0 ? diff / 1000 : 0);
  }, 0);
